import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button, Dialog, Portal, RadioButton } from 'react-native-paper';

const DialogRadioButtonGroup = ({
  colors,
  data,
  handleChange,
  label,
  fieldName,
  value,
}) => {
  const [visible, setVisible] = useState(false);

  const showDialog = () => setVisible(true);

  const hideDialog = () => setVisible(false);

  return (
    <View>
      <Button onPress={showDialog} uppercase={false}>
        {label} ({value})
      </Button>
      <Portal>
        <Dialog visible={visible} onDismiss={hideDialog}>
          <Dialog.Title>{label}</Dialog.Title>
          <Dialog.Content>
            <RadioButton.Group
              onValueChange={handleChange(fieldName)}
              value={value}
            >
              {data.map((val) => (
                <View key={val} style={styles.radioContainer}>
                  <View style={styles.radioText}>
                    <Text>{val}</Text>
                  </View>
                  <View style={styles.radioButton}>
                    <RadioButton color={colors.primary} value={val} />
                  </View>
                </View>
              ))}
            </RadioButton.Group>
          </Dialog.Content>
        </Dialog>
      </Portal>
    </View>
  );
};

const styles = StyleSheet.create({
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  radioText: { flex: 4 },
  radioButton: { flex: 1 },
});

export default DialogRadioButtonGroup;
